// src/directives/lazy-load.js
export default {
  bind(el, binding) {
    const loadImage = () => {
      el.src = binding.value; // Set the image source
      observer.unobserve(el); // Stop observing the element
      console.log("TERLOAD : ", binding.value)
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadImage();
        }
      });
    });

    observer.observe(el); // Start observing the element
  }
};


// WEBPACK FOOTER //
// ./src/utils/directives/lazy-load.js